import { call, put, takeLatest } from 'redux-saga/effects';

import { getSkvpzuList } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getSkvpzuList);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* skvpzuListSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
